export class ShowBlocks {
    constructor(optionalOptions = {}) {
        this._linkbloks = document.querySelectorAll('.show-block');

        if (!this._linkbloks) {
            this.destructor();
            return true;
        }

        let showBlock
        let hideThis
        let blocks

        this._linkbloks.forEach((button) => {
            button.addEventListener("click", (event) => {
                event.preventDefault()

                showBlock = button.dataset.show
                hideThis = button.dataset.hidethis

                if (!showBlock) {
                    this.destructor();
                    return false
                }

                blocks = document.querySelectorAll(showBlock);
                if (blocks) {
                    blocks.forEach((block) => {
                        block.style.display = 'block';
                    })
                }

                if (hideThis === "true") {
                    button.style.display = "none";
                }

                return false
            })
        })
    }

    destructor() {
        this._linkbloks = null;
    }
}

export default new ShowBlocks();